/*
 * Copyright (C) 2025 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {ErrorBoundary} from '@instructure/platform-error-boundary'
import {PropsWithChildren} from 'react'
import {GenericErrorPage} from '@instructure/platform-generic-error-page'
import {reportError, canvasErrorPageTranslations} from '@canvas/error-page-utils'
import errorShipUrl from '@instructure/platform-images/assets/ErrorShip.svg'
import {useScope as createI18nScope} from '@canvas/i18n'

const I18n = createI18nScope('block_content_editor')

const BlockContentEditorGenericErrorPage = () => {
  return (
    <GenericErrorPage
      imageUrl={errorShipUrl}
      onReportError={reportError}
      translations={canvasErrorPageTranslations}
      errorSubject={I18n.t('Block Content Editor Error')}
    />
  )
}

export const BlockContentEditorErrorBoundary = (props: PropsWithChildren) => {
  return (
    <ErrorBoundary
      errorComponent={BlockContentEditorGenericErrorPage}
      beforeCapture={scope => {
        scope.setTag('inst.feature', 'block_content_editor')
      }}
    >
      {props.children}
    </ErrorBoundary>
  )
}
